<template>
    <div class="grid">
        <div class="col-12">
            <div class="p-fluid">
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Salary</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="model.salary.salary"
                            :class="{ 'p-invalid': !model.salary }"  :disabled=true />
                        <small class="p-invalid" v-if="!model.salary.salary">Contract Duration is
                            required.</small>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Fixed Allowance</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="model.salary.fixed_allowance" :disabled="true" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Transport Allowance</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID"
                            v-model="model.salary.transport_allowance" :disabled="true" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Functional Allowance</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID"
                            v-model="model.salary.functional_allowance" :disabled="true" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Meal Allowance</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="model.salary.meal_allowance" :disabled="true" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Special Allowance</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID"
                            v-model="model.salary.special_allowance" :disabled="true" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Communication Allowance</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID"
                            v-model="model.salary.communication_allowance" :disabled="true" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Normal Overtime (Jam)</label>
                    <div class="col-4 md:col-1">
                        <InputText type="number" max="1000" id="overtime_hour" mode="decimal" locale="id-ID"
                            v-model="form.overtime_hour" @input="calculateNormalOvertime(form.overtime_hour)" />
                    </div>
                    <div class="col-4 md:col-2">
                        <InputNumber id="salary" placeholder="Lembur Hari Normal" v-model="form.overtime_money" />
                    </div>
                    <div class="col-4 md:col-2">
                        <Button label="Rumus" @click="displayNormalOTFormula = true" />
                    </div>
                    <Dialog header="Rumus Normal Overtime" v-model:visible="displayNormalOTFormula" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :modal="true">
                        <ul class="line-height-3 m-0">
                            <li>1 Jam Pertama = 1.5 Jam</li>
                            <li>2 Jam => 1 Jam Pertama + 2 = 3.5</li>
                            <li>3 Jam => 1 Jam Pertama + 2 + = 5.5</li>
                        </ul>
                        <p class="line-height-3 m-0">
                            Hasil Penjumlahan Jam Tersebut / 173 * Gaji Pokok
                        </p>
                        <template #footer>
                            <Button label="Ok" @click="displayNormalOTFormula = false" icon="pi pi-check" class="p-button-outlined"/>
                        </template>
                    </Dialog>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Hari Libur Overtime (Jam)</label>
                    <div class="col-4 md:col-1">
                        <InputText type="number" max="1000" id="salary" mode="decimal" locale="id-ID"
                            v-model="form.dayoff_overtime_hour" @input="calculateDayOffOvertime(form.dayoff_overtime_hour)" />
                    </div>
                    <div class="col-4 md:col-2">
                        <InputNumber id="salary" placeholder="Lembur Hari Libur" v-model="form.dayoff_overtime_money" />
                    </div>
                    <div class="col-4 md:col-2">
                        <Button label="Rumus" @click="displayDayoffOTFormula = true" />
                    </div>
                    <Dialog header="Rumus Hari Libur Overtime" v-model:visible="displayDayoffOTFormula" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :modal="true">
                        <ul class="line-height-3 m-0">
                            <li>1 - 8 Jam Pertama * 2 = 16</li>
                            <li>9 Jam => 8 Jam Pertama + 3 = 19</li>
                            <li>10 Jam dan seterusnya => 8 Jam Pertama + 1 Jam Setelahnya + 4(x) = 23</li>
                        </ul>
                        <p class="line-height-3 m-0">
                            Hasil Penjumlahan Jam Tersebut / 173 * Gaji Pokok
                        </p>
                        <template #footer>
                            <Button label="Ok" @click="displayDayoffOTFormula = false" icon="pi pi-check" class="p-button-outlined"/>
                        </template>
                    </Dialog>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Insentive</label>
                    <div class="col-12 md:col-5">
                        <InputNumber  id="salary" mode="decimal" locale="id-ID"
                        v-model="form.insentive"/>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Leftover Salary</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID"
                            v-model="form.leftover_salary"/>
                    </div>
                </div>
            </div>
            <div class="field grid">
                <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">
                    Total Income
                </label>
                <div class="col-12 md:col-5">
                    {{ netIncome }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Checkbox from 'primevue/checkbox';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
export default {
    components: {
        Button, Calendar, Checkbox, Dialog, Dropdown, InputText, InputNumber,
    },
    props: ['model'],
    computed: {
        netIncome(){
            return this.calculateNetIncome();
        },
    },
    data(){
        return {
            form: this.$page.props.payroll ? {
                overtime_hour : this.$page.props.payroll.overtime_hour,
                overtime_money : this.$page.props.payroll.overtime_money,
                dayoff_overtime_hour : this.$page.props.payroll.dayoff_overtime_hour,
                dayoff_overtime_money : this.$page.props.payroll.dayoff_overtime_money,
                insentive : this.$page.props.payroll.insentive,
                leftover_salary : this.$page.props.payroll.leftover_salary,
             } : {},
            displayNormalOTFormula: false,
            displayDayoffOTFormula: false,
        }
    },
    methods:{
        calculateNetIncome(){
            let income = this.model.salary;
            let netIncome = 0;

            income.salary = !isNaN(parseInt(income.salary)) ? parseInt(income.salary) : 0;
            income.fixed_allowance = !isNaN(parseInt(income.fixed_allowance)) ? parseInt(income.fixed_allowance) : 0;
            income.transport_allowance = !isNaN(parseInt(income.transport_allowance)) ? parseInt(income.transport_allowance) : 0;
            income.functional_allowance = !isNaN(parseInt(income.functional_allowance)) ? parseInt(income.functional_allowance) : 0;
            income.meal_allowance = !isNaN(parseInt(income.meal_allowance)) ? parseInt(income.meal_allowance) : 0;
            income.special_allowance = !isNaN(parseInt(income.special_allowance)) ? parseInt(income.special_allowance) : 0;
            income.communication_allowance = !isNaN(parseInt(income.communication_allowance))? parseInt(income.communication_allowance) : 0;
            this.form.insentive = !isNaN(parseInt(this.form.insentive)) ? parseInt(this.form.insentive) : 0 ;
            this.form.leftover_salary = !isNaN(parseInt(this.form.leftover_salary)) ? parseInt(this.form.leftover_salary) : 0;
            this.form.overtime_money = !isNaN(parseInt(this.form.overtime_money)) ? parseInt(this.form.overtime_money) : 0;
            this.form.dayoff_overtime_money = !isNaN(parseInt(this.form.dayoff_overtime_money)) ? parseInt(this.form.dayoff_overtime_money) : 0;

            netIncome = income.salary + income.fixed_allowance + income.fixed_allowance +
                        income.transport_allowance + income.functional_allowance + income.meal_allowance +
                        income.special_allowance + income.communication_allowance +
                        this.form.insentive + this.form.leftover_salary + this.form.overtime_money + this.form.dayoff_overtime_money ;

            return netIncome.toLocaleString('id-ID');
        },
        calculateNormalOvertime(value){
            let baseSalary = this.model.salary.salary ?? 0;
            let overtimeSalary = 0;

            if(value > 1){
                let hour = value - 1;
                overtimeSalary = (1.5 + hour * 2) / 173 * baseSalary;
            }
            if(value == 1){
                overtimeSalary = 1.5 / 173 * baseSalary;
            }

            this.form.overtime_money = overtimeSalary;
        },
        calculateDayOffOvertime(value){
            let baseSalary = this.model.salary.salary ?? 0;
            let overtimeSalary = 0;

            if(value >= 10){
                let hour = (value - 9) * 4;
                overtimeSalary = ((8 * 2) + 3 + hour) / 173 * baseSalary;
            }
            if(value == 9){
                overtimeSalary = ((8 * 2) + 3) / 173 * baseSalary;
            }
            if(value >= 1 && value <= 8){
                overtimeSalary = (value * 2) / 173 * baseSalary;
            }

            this.form.dayoff_overtime_money = overtimeSalary;
        }
    }
}
</script>
